import api from '../utils/apiClient';

/** Public list (mobile app uses this too). */
export const APP_PROMOS_PUBLIC_PATH = '/api/app-promos';

/** Admin CRUD — requires Bearer admin JWT (see [apiClient] interceptor). */
export const APP_PROMOS_ADMIN_PATH = '/api/admin/app-promos';

/** @returns {Promise<{ success: boolean; data: object[] }>} */
export async function listAppPromos() {
  const { data } = await api.get(APP_PROMOS_PUBLIC_PATH);
  return data;
}

/**
 * @param {FormData} formData — fields: title, link, image (file), isActive?, order?, screen?
 */
export async function createAppPromo(formData) {
  const { data } = await api.post(APP_PROMOS_ADMIN_PATH, formData);
  return data;
}

/**
 * @param {string} id
 * @param {FormData} formData
 */
export async function updateAppPromo(id, formData) {
  const { data } = await api.put(`${APP_PROMOS_ADMIN_PATH}/${encodeURIComponent(id)}`, formData);
  return data;
}

/**
 * @param {string} id
 */
export async function deleteAppPromo(id) {
  const { data } = await api.delete(`${APP_PROMOS_ADMIN_PATH}/${encodeURIComponent(id)}`);
  return data;
}
